







import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";
import { StringFilterParameter } from "../../system/filters";
import StringFilter from "../../system/filters/StringFilter.vue";
import { FormatSetFilterParameter } from ".";

@Component({
  components: {
    StringFilter,
  },
})
export default class FormatSetReferenceFilter extends Mixins(ModelEditableMixin) {
  editingSource: FormatSetFilterParameter;

  get name(): StringFilterParameter {
    return this.editingSource.formatName;
  }

  set name(source: StringFilterParameter) {
    this.writeProperty(s => s.formatName = source);
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }
}
